import { Typography } from '@components/Typography';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { POST_CHANNEL_LABEL } from '@constants/social-posts';
import { formatNumber, formatOptionalNumber as formatOptional } from '@helpers/formatNumbers';
import { TableCellText } from '../../Feedback/FeedbackTable';

// Per-profile child rows for an expanded campaign. The parent campaign-total row is
// identified by `campaignTotal=true`; everything else with the same campaignId becomes a
// child row showing one (location, platform) tuple's metrics.
export const getCollapsibleTableBody = (data, index) => {
    const parent = data?.[index];
    if (!parent || !parent.campaignTotal) return [];
    const tableData = data.filter(item => item.campaignId === parent.campaignId && !item.campaignTotal);

    return tableData.map(row => {
        const { platform, locationName, reach, likes, comments, shares, clicks, saves } = row;

        return [
            {
                component: (
                    <IconButton style={{ opacity: 0, cursor: 'auto' }} disableRipple>
                        <KeyboardArrowUpIcon />
                    </IconButton>
                ),
                width: '5%',
            },
            {
                component: (
                    <Typography variant="subtitle2" align="left">
                        {locationName || 'NA'}
                        {' · '}
                        <Typography variant="body2" component="span" sx={{ color: 'var(--text-secondary)' }}>
                            {POST_CHANNEL_LABEL[platform] || 'NA'}
                        </Typography>
                    </Typography>
                ),
                width: '25%',
            },
            {
                component: (
                    <TableCellText variant="body2" align="right">
                        {formatNumber(reach)}
                    </TableCellText>
                ),
                width: '10%',
            },
            {
                component: (
                    <TableCellText variant="body2" align="right">
                        {formatNumber(likes)}
                    </TableCellText>
                ),
                width: '10%',
            },
            {
                component: (
                    <TableCellText variant="body2" align="right">
                        {formatNumber(comments)}
                    </TableCellText>
                ),
                width: '10%',
            },
            {
                component: (
                    <TableCellText variant="body2" align="right">
                        {formatNumber(shares)}
                    </TableCellText>
                ),
                width: '10%',
            },
            {
                component: (
                    <TableCellText variant="body2" align="right">
                        {formatOptional(clicks)}
                    </TableCellText>
                ),
                width: '10%',
            },
            {
                component: (
                    <TableCellText variant="body2" align="right">
                        {formatOptional(saves)}
                    </TableCellText>
                ),
                width: '10%',
            },
        ];
    });
};
